import { render } from "./copy-strategy.vue?vue&type=template&id=108e79c8"
import script from "./copy-strategy.vue?vue&type=script&lang=js"
export * from "./copy-strategy.vue?vue&type=script&lang=js"

import "./copy-strategy.vue?vue&type=style&index=0&id=108e79c8&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__